import { useRoutes } from "react-router-dom";
import CreateCard from "../../Component/CreateCard.js"
import EditFormRoute from "../../Component/Forms/EditFormRoute.js"

import PasswordChange from "./passwordChange/Create.js"
import ProtectedRoute from "../RouteProtect.js"


const RoutesArray = [
    {
        path: "*",
        element: <h1>This is 404</h1>
    },
    {
        path: "",
        element:
            (
                <ProtectedRoute requiredRole="admin" routeAuth="carrier" >
                    <PasswordChange />
                </ProtectedRoute>
            )
    },
    {
        path: "/:id",
        element: (
            <ProtectedRoute requiredRole="admin" routeAuth="carrier" >
                <EditFormRoute />
            </ProtectedRoute>
        )
    },
    {
        path: "/changePassword",
        element: (
            <ProtectedRoute requiredRole="admin" routeAuth="carrier" >
                <PasswordChange />
            </ProtectedRoute>
        )
    },
   
];


export default function MangeRoutes() {
    return useRoutes(RoutesArray)
};